import { styled, Typography } from '@mui/material';

export const ChatText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'optVariant' && prop !== 'isActive' && prop !== 'isCurrentUser',
})<{ optVariant?: 'chatsTitle' | 'chatsTabTitle' | 'messageText' | 'tabContentTitle' | 
'messageTimestamp' | 'emptyChatTitle' | 'emptyChatDescription'
| 'chatModalHeader'; isActive?: boolean; isCurrentUser?: boolean }>(
  ({ theme, optVariant, isActive, isCurrentUser }) => {
    switch (optVariant) {
      case 'chatsTitle':
        return {
          fontWeight: 600,
          color: isActive ? 'white' : '#2D3748',
          fontSize: '0.9rem',
          [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
          },
        };

      case 'chatsTabTitle':
        return {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          flex: 1,
          fontWeight: isActive ? 600 : 500,
          color: isActive ? theme.palette.primary.main : '#2D3748',
          fontSize: '0.85rem',
          [theme.breakpoints.up('md')]: {
            fontSize: '0.95rem',
          },
        };

      case 'tabContentTitle':
        return {
          fontWeight: 600,
          color: '#2D3748',
          fontSize: '0.9rem',
          [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
          },
        };

      case 'messageText':
        return {
          fontSize: '0.9rem',
          [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
          },
        };
      
      case 'messageTimestamp':
        return {
          display: 'block',
          marginTop: theme.spacing(0.5),
          color: isCurrentUser ? 'rgba(255,255,255,0.7)' : '#718096',
          fontSize: '0.7rem',
          [theme.breakpoints.up('md')]: {
            fontSize: '0.8rem',
          },
        };

      case 'emptyChatTitle':
        return {
          marginBottom: theme.spacing(1),
          fontSize: '1.1rem',
          fontWeight: 600,
          color: theme.palette.text.primary,
          [theme.breakpoints.up('md')]: {
            fontSize: '1.25rem',
          },
        };

      case 'emptyChatDescription':
        return {
          textAlign: 'center',
          fontSize: '0.85rem',
          maxWidth: '280px',
          lineHeight: 1.5,
          color: theme.palette.text.secondary,
          [theme.breakpoints.up('md')]: {
            fontSize: '0.875rem',
            maxWidth: '320px',
          },
        };

      case 'chatModalHeader':
        return {
          color: '#2D3748',
          fontWeight: 600,
          fontSize: '1.25rem',
        };
    }
  },
);